<div class="login2background" style="background-image: url(assets/img/global/fundo_login.jpg)">
  <div class="main-content container-fluid">
    <div class="splash-container">
      <div class="card">
        <div class="card-header" style="background: none; border-bottom: 0px">
          <img src="assets/img/global/logo.png" width="150" height="55">
        </div>
        <hr />
        <p-selectButton [options]="opcoesAcesso" [(ngModel)]="servidor" (click)="this.nomeField.nativeElement.focus();">
        </p-selectButton>
        <div class="card-body">
          <form id="login-form" (ngSubmit)="f.form.valid" #f="ngForm" novalidate autocomplete="off"
            class="form-horizontal">
            <div class="row">
              <div class="col-lg-6 col-md-8 col-sm-9">
                <div class="form-group row">
                  <label for="nome" class="col-sm-4 col-form-label">Nome</label>
                  <div class="col-sm-8">
                    <input #nome [(ngModel)]="entidade.nome" style="font-weight: bold"
                      [ngClass]="{ 'is-invalid': f.submitted && nome.invalid }" required type="text"
                      class="form-control" name="nome" placeholder="Primeiro nome" id="nome">
                    <div *ngIf="f.submitted && nome.invalid" class="invalid-feedback">
                      <div *ngIf="nome.errors.required">Nome é requerido</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-8 col-sm-9">
                <div class="form-group row">
                  <label for="sobrenome" class="col-sm-4 col-form-label">Sobrenome</label>
                  <div class="col-sm-8">
                    <input [(ngModel)]="entidade.sobrenome" #sobrenome
                      [ngClass]="{ 'is-invalid': f.submitted && sobrenome.invalid }" required type="text"
                      class="form-control" name="sobrenome" placeholder="Último nome" id="sobrenome">
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="cpf" class="col-sm-2 col-form-label">CPF</label>
              <div class="col-sm-4">
                <input [imask]="{mask: '000.000.000-00'}" unmask="true" [(ngModel)]="entidade.cpf" #cpf
                  [ngClass]="{ 'is-invalid': f.submitted && cpf.invalid }" required type="text" class="form-control"
                  name="cpf" placeholder="Número do seu CPF" id="cpf">
              </div>
              <label for="fone" class="col-sm-2 col-form-label">Telefone</label>
              <div class="col-sm-4">
                <input [imask]="{mask: [ {mask: '0000-0000'}, {mask: '00000-0000'}, {mask: '(00) 0000-0000'}, {mask: '(00) 00000-0000'} ]}" unmask="true" #fone
                  [(ngModel)]="entidade.telefone" [ngClass]="{ 'is-invalid': f.submitted && fone.invalid }" required
                  type="text" class="form-control" name="fone" placeholder="Telefone para contato" id="fone">
              </div>
            </div>
            <div class="form-group row">
              <label for="email" class="col-sm-2 col-form-label">E-mail</label>
              <div class="col-sm-10">
                <input [(ngModel)]="entidade.email" #email [ngClass]="{ 'is-invalid': f.submitted && email.invalid }"
                  required type="text" class="form-control" name="email" placeholder="Seu e-mail para acesso ao sistema"
                  id="email">
              </div>
            </div>
            <div *ngIf="servidor">
              <hr />
              <div class="form-group row">
                <label for="sistema" class="col-sm-2 col-form-label">Sistema</label>
                <div class="col-sm-10">
                  <select [(ngModel)]="entidade.sistema" name="sistema" id="sistema" class="form-control custom-select"
                    #sistema [ngClass]="{ 'is-invalid': f.submitted && sistema.invalid }" required>
                    <option [ngValue]="item.id" *ngFor="let item of listaSistemas">
                      {{item.nome}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <label for="orgao" class="col-sm-2 col-form-label">Órgão</label>
                <div class="col-sm-10">
                  <select [compareWith]="compareFn" #orgao [(ngModel)]="entidade.orgao" name="orgao" id="orgao"
                    class="form-control custom-select" [ngClass]="{ 'is-invalid': f.submitted && orgao.invalid }"
                    required>
                    <option [ngValue]="item" *ngFor="let item of listaOrgaos">
                      {{item.nome}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <hr />
            <div class="row mt-4">
              <div class="col-12">
                <button (click)="registrar()" class="btn btn-primary btn-sm float-right">Enviar</button>
                <a routerLink="/login" class="btn btn-link btn-sm float-right mr-3">Cancelar</a>
              </div>
            </div>
            <!-- <pre>{{ entidade | json}}</pre> -->
          </form>
        </div>
      </div>
    </div>
  </div>
</div>